import HeaderSearch from '@/components/componentWap/HeaderSearch.vue'
import { Component, Vue } from 'vue-property-decorator'
import { downList, downDetail } from '@/api'
@Component({
    name: 'Download',
    components: {
        HeaderSearch
    }
})
export default class extends Vue {
    private loading = false
    private dataList = []
    private async initData() {
        this.loading = true
        let res = await downList().finally(() => this.loading = false)
        this.dataList = res.data.list
    }
    private async downFile(item: any) {
        const res = await downDetail(item.id)
        const detail = res.data
        if (!detail.resUrl) return
        fetch(detail.resUrl).then(res => {
            res.blob().then(blob => {
                const a = document.createElement('a');
                const url = window.URL.createObjectURL(blob);
                a.href = url;
                a.download = detail.title || '';
                a.click();
                window.URL.revokeObjectURL(url);
            })
        })
    }
    created() {
        this.initData()
    }
}